
import React from 'react';
import { Link } from 'react-router-dom';
import { Layout, Sparkles, Globe, Zap, ArrowRight } from 'lucide-react';
import { Logo } from '../../components/ui/Logo';

const SitemapPage: React.FC = () => {
  const sections = [
    {
      title: "Plataforma",
      icon: Globe,
      links: [
        { label: "Página Inicial", to: "/" },
        { label: "Login", to: "/login" },
      ]
    },
    {
      title: "Área do Creator",
      icon: Layout,
      links: [
        { label: "Dashboard", to: "/admin/dashboard" },
        { label: "Linktree Bio", to: "/admin/bio-links" },
        { label: "Page Builder", to: "/admin/studio" },
        { label: "Viral Insights", to: "/admin/insights" },
      ]
    },
    {
      title: "Legal & Info",
      icon: Sparkles,
      links: [
        { label: "Política de Privacidade", to: "/politica-de-privacidade" },
        { label: "Sitemap XML", to: "/sitemap.xml", external: true },
      ]
    }
  ];

  return (
    <div className="min-h-screen bg-[#050505] text-white font-sans selection:bg-brand-green selection:text-black">
      <nav className="p-8 container mx-auto flex justify-between items-center relative z-10">
        <Link to="/" className="flex items-center gap-4 group">
          <Logo size="md" className="group-hover:rotate-12 transition-all" />
          <span className="text-xl font-black tracking-tighter uppercase italic">HeroFrog<span className="text-brand-green">.</span></span>
        </Link>
        <Link to="/login" className="text-[10px] font-black uppercase tracking-widest bg-white text-black px-8 py-3 rounded-full hover:bg-brand-green hover:text-black transition-all shadow-bold-white">
          Acessar
        </Link>
      </nav>

      <main className="container mx-auto px-8 py-24 relative z-10 max-w-6xl">
        <header className="mb-24 text-center space-y-6">
           <h1 className="text-6xl md:text-8xl font-black italic uppercase tracking-tighter leading-none">MAPA DO <br/> <span className="text-brand-green">SISTEMA.</span></h1>
           <p className="text-gray-500 font-medium text-xl max-w-xl mx-auto italic uppercase tracking-widest text-[10px]">Estrutura Green Ops v2.0</p>
        </header>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
           {sections.map((section, idx) => (
             <div key={idx} className="bg-white/5 border border-white/10 rounded-[3rem] p-12 hover:border-brand-green/30 transition-all group">
                <div className="w-16 h-16 bg-brand-green/10 rounded-3xl flex items-center justify-center text-brand-green mb-10 group-hover:scale-110 transition-transform">
                   <section.icon className="w-8 h-8" />
                </div>
                <h3 className="text-2xl font-black uppercase italic tracking-tighter mb-8 border-b border-white/10 pb-4">{section.title}</h3>
                <ul className="space-y-6">
                   {section.links.map((link, lIdx) => (
                     <li key={lIdx}>
                        {link.external ? (
                          <a href={link.to} className="text-gray-500 hover:text-white transition-all font-bold text-sm flex items-center justify-between group/link">
                             {link.label} <Zap className="w-4 h-4 opacity-0 group-hover/link:opacity-100 text-brand-green transition-opacity" />
                          </a>
                        ) : (
                          <Link to={link.to} className="text-gray-500 hover:text-brand-green transition-all font-bold text-sm flex items-center justify-between group/link">
                             {link.label} <ArrowRight className="w-4 h-4 opacity-0 group-hover/link:opacity-100 transition-opacity group-hover/link:translate-x-1" />
                          </Link>
                        )}
                     </li>
                   ))}
                </ul>
             </div>
           ))}
        </div>
      </main>

      <footer className="py-20 bg-black border-t border-white/10 text-center mt-32">
         <p className="text-[10px] font-black uppercase tracking-[0.8em] text-gray-700">HEROFROG CLOUD • GREEN OPS</p>
      </footer>
    </div>
  );
};

export default SitemapPage;
